import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DialogData } from 'src/app/models/dialog-data';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { SubService } from 'src/app/services/sub.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { BeUsuario } from 'src/app/models/BeUsuario';
import { ListaDadosColuna } from 'src/app/components/lista-dados/lista-dados.component';

@Component({
  selector: 'app-usuarios',
  templateUrl: './list-usuarios.component.html',
  styleUrls: ['./list-usuarios.component.css']
})
export class ListUsuariosComponent implements OnInit, OnDestroy {
  public usuarios: (BeUsuario & { noCpfjFormatado: string })[] = [];
  public colunasListaDados: ListaDadosColuna[] = [
    {
      campo: 'noCpfjFormatado',
      rotulo: 'CPF/CNPJ',
      tamanho: '100px'
    },
    {
      campo: 'noNomeCompleto',
      rotulo: 'Nome',
      tamanho: '200px'
    },
    {
      campo: 'noEmail',
      rotulo: 'Email',
      tamanho: '250px'
    }
  ];
  public subscription?: Subscription;

  public constructor(
    private httpClient: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private sub: SubService,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
  ) {
  }

  public ngOnInit(): void {
    this.subscription = this.httpClient.get<BeUsuario[]>(
      `/api/Usuarios`
    ).subscribe({
      next: (res) => {
        this.unsubscribe();
        this.onResult(res);
      },
      error: (err) => {
        this.unsubscribe();
        this.snackBarService.exibirErro(`Erro! - ${err.status} - ${err.statusText}`);
      }
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe();
  }

  public onCreate() {
    this.router.navigate(['/novo-usuario'], { relativeTo: this.route });
  }

  public onEdit(usuario: BeUsuario) {
    this.router.navigate(['/usuario', usuario.idUsuario], { relativeTo: this.route });
  }

  public onDelete(usuario: BeUsuario) {
    this.showDialog('Deseja excluir esse registro?', 'Alerta', 'Não', 'Sim', usuario);
  }

  public showDialog(msg: string, statusMsg: string, button: string = 'OK', secondButton: string = '', usuario: BeUsuario = {} as BeUsuario) {
    if (this.subscription)
      return;
    const dialogData: DialogData = {
      title: statusMsg,
      message: msg,
      buttonText: button,
      secondButtonText: secondButton,
    };
    const dialogRef = this.dialog.open(DialogComponent, { data: dialogData });
    dialogRef.afterClosed().subscribe((result) => {
      this.unsubscribe();
      if (result) {
        this.sub.reset(this.httpClient.delete(`/api/Usuarios/${usuario.idUsuario}`),
          () => this.onDeleteConfirm(usuario),
          () => this.showDialog('Não foi possível excluir o registro!', 'Erro')
        );
      }
    })
  }

  private onDeleteConfirm(res: BeUsuario) {
    this.usuarios = this.usuarios.filter(usuario => usuario.idUsuario !== res.idUsuario);
    this.snackBarService.exibirSucesso('Registro excluído!');
  }

  private unsubscribe() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }

  private onResult(res: BeUsuario[]) {
    this.usuarios = (res ?? []).map(usuario => ({
      ...usuario,
      noCpfjFormatado: this.formatCpfCnpj(usuario.noCpfj)
    }));
  }

  private formatCpfCnpj(valor?: string): string {
    const digitos = (valor ?? '').replace(/\D/g, '');

    if (digitos.length === 11) {
      return digitos.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    if (digitos.length === 14) {
      return digitos.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }

    return valor ?? '';
  }
}
